var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var ApiFavorites = /** @class */ (function () {
    function ApiFavorites(baseUri) {
        var _this = this;
        this.getLists = function (callback) { return __awaiter(_this, void 0, void 0, function () {
            var api, response, json, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        api = "".concat(this.baseUri, "/api/favorite-lists");
                        return [4 /*yield*/, fetch(api, {
                                method: "GET",
                                credentials: "include"
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            console.error('Failed to get favorite lists:', response.status);
                            callback([]);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        callback(json);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Error fetching favorite lists:', error_1);
                        callback([]);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.createList = function (name, callback) { return __awaiter(_this, void 0, void 0, function () {
            var api, response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = "".concat(this.baseUri, "/api/favorite-lists");
                        return [4 /*yield*/, fetch(api, {
                                method: "POST",
                                credentials: "include",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({ name: name })
                            })];
                    case 1:
                        response = _a.sent();
                        if (!(callback && response.ok)) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.clone().json()];
                    case 2:
                        json = _a.sent();
                        callback(json);
                        _a.label = 3;
                    case 3: return [2 /*return*/, response];
                }
            });
        }); };
        this.deleteList = function (listId, callback) { return __awaiter(_this, void 0, void 0, function () {
            var api, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = "".concat(this.baseUri, "/api/favorite-lists/").concat(listId);
                        return [4 /*yield*/, fetch(api, {
                                method: "DELETE",
                                credentials: "include"
                            })];
                    case 1:
                        response = _a.sent();
                        if (callback) {
                            callback(response.status === 204);
                        }
                        return [2 /*return*/, response];
                }
            });
        }); };
        this.renameList = function (listId, name, callback) { return __awaiter(_this, void 0, void 0, function () {
            var api, response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = "".concat(this.baseUri, "/api/favorite-lists/").concat(listId);
                        return [4 /*yield*/, fetch(api, {
                                method: "PUT",
                                credentials: "include",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({ name: name })
                            })];
                    case 1:
                        response = _a.sent();
                        if (!(callback && response.ok)) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.clone().json()];
                    case 2:
                        json = _a.sent();
                        callback(json);
                        _a.label = 3;
                    case 3: return [2 /*return*/, response];
                }
            });
        }); };
        this.getListItems = function (listId, callback) { return __awaiter(_this, void 0, void 0, function () {
            var api, response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = "".concat(this.baseUri, "/api/favorite-lists/").concat(listId, "/items");
                        return [4 /*yield*/, fetch(api, {
                                method: "GET",
                                credentials: "include"
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        if (callback) {
                            callback(json);
                        }
                        return [2 /*return*/, json];
                }
            });
        }); };
        this.addProductToLists = function (productId, listIds, callback) { return __awaiter(_this, void 0, void 0, function () {
            var api, response, json, error_2, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        api = "".concat(this.baseUri, "/api/favorite-lists/add-product");
                        return [4 /*yield*/, fetch(api, {
                                method: "POST",
                                credentials: "include",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({ productId: productId, listIds: listIds })
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        if (callback) {
                            callback(json);
                        }
                        return [2 /*return*/, json];
                    case 3:
                        error_2 = _a.sent();
                        console.error('Error adding product to lists:', error_2);
                        result = { success: false, inLists: [] };
                        if (callback) {
                            callback(result);
                        }
                        return [2 /*return*/, result];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.removeProductFromList = function (itemId, callback) { return __awaiter(_this, void 0, void 0, function () {
            var api, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = "".concat(this.baseUri, "/api/favorite-lists/remove-product/").concat(itemId);
                        return [4 /*yield*/, fetch(api, {
                                method: "DELETE",
                                credentials: "include"
                            })];
                    case 1:
                        response = _a.sent();
                        if (callback) {
                            callback(response.status === 204);
                        }
                        return [2 /*return*/, response];
                }
            });
        }); };
        this.getProductStatus = function (productId, callback) { return __awaiter(_this, void 0, void 0, function () {
            var api, response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = "".concat(this.baseUri, "/api/favorite-lists/product-status/").concat(productId);
                        return [4 /*yield*/, fetch(api, {
                                method: "GET",
                                credentials: "include"
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        if (callback) {
                            callback(json);
                        }
                        return [2 /*return*/, json];
                }
            });
        }); };
        this.getProductsStatus = function (productIds, callback) { return __awaiter(_this, void 0, void 0, function () {
            var api, response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = "".concat(this.baseUri, "/api/favorite-lists/products-status");
                        return [4 /*yield*/, fetch(api, {
                                method: "POST",
                                credentials: "include",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({ productIds: productIds })
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        if (callback) {
                            callback(json);
                        }
                        return [2 /*return*/, json];
                }
            });
        }); };
        this.baseUri = baseUri;
    }
    return ApiFavorites;
}());
export default ApiFavorites;
